<div class="packages-widget">
    <div class="packages-header">
        <h4>
            <i class="pi pi-box"></i>
            Packages
            @if (totalCount() > 0) {
                <span class="package-count">{{ totalCount() }}</span>
            }
        </h4>
        @if (totalCount() > 0) {
            <a routerLink="/packages" class="view-all-link">View all</a>
        }
    </div>

    <div class="packages-content">
        @if (loading()) {
            <app-loading-skeleton preset="list" [count]="3" label="Loading packages" />
        } @else if (error()) {
            <app-empty-state icon="pi pi-exclamation-triangle" tone="error" title="Couldn't load packages" [description]="error()" [compact]="true" [fill]="true" />
        } @else if (displayedPackages().length === 0) {
            <app-empty-state icon="pi pi-box" title="No packages uploaded" [compact]="true" [fill]="true">
                <a routerLink="/packages" class="upload-link">Upload a package</a>
            </app-empty-state>
        } @else {
            <div class="packages-list">
                @for (pkg of displayedPackages(); track pkg.package.id) {
                    <div class="package-item" [class.deployable]="!!pkg.latestVersion" (click)="pkg.latestVersion && deployPackage(pkg)" [pTooltip]="pkg.latestVersion ? 'Deploy latest version' : ''" tooltipPosition="left">
                        <div class="package-info">
                            <div class="package-name">{{ pkg.package.name }}</div>
                            <div class="package-namespace">{{ pkg.package.programNamespace }}</div>
                        </div>
                        <div class="package-version">
                            @if (pkg.latestVersion) {
                                <p-tag [value]="pkg.latestVersion.assemblyVersion" severity="success" class="version-tag"></p-tag>
                                <div class="version-badges">
                                    @if (pkg.latestVersion.isDebugBuild) {
                                        <p-tag value="Debug" severity="warn" [rounded]="true" class="small-tag"></p-tag>
                                    } @else {
                                        <p-tag value="Release" severity="info" [rounded]="true" class="small-tag"></p-tag>
                                    }
                                    @if (pkg.latestVersion.uploadSource === 'github-actions') {
                                        <p-tag value="CI" severity="secondary" [rounded]="true" class="small-tag" pTooltip="Built via GitHub Actions"></p-tag>
                                    }
                                </div>
                                <div class="version-date" [pTooltip]="formatDateTime(pkg.latestVersion.buildTimeUtc || pkg.latestVersion.uploadedUtc)">
                                    @if (pkg.latestVersion.buildTimeUtc) {
                                        Built {{ formatRelativeTime(pkg.latestVersion.buildTimeUtc) }}
                                    } @else {
                                        {{ formatRelativeTime(pkg.latestVersion.uploadedUtc) }}
                                    }
                                </div>
                                <i class="pi pi-cloud-upload deploy-icon"></i>
                            } @else {
                                <span class="no-version">No versions</span>
                            }
                        </div>
                    </div>
                }
            </div>

            @if (hasMore()) {
                <div class="more-indicator">
                    <a routerLink="/packages" class="text-color-secondary text-sm">+{{ hiddenCount() }} more packages</a>
                </div>
            }
        }
    </div>
</div>
